//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import Model from '@/models/mobile'

export default {

  data() {
    return {
      list: [],
    }

  },
  created(){
   this.setupData();

  },
  methods:{

 async  setupData(){

        const {
          parkNo,
          carNo,
        } = this.$route.params;

        let {data} = await Model.rechargeRecordList({
          parkNo,
          carNo
        });
        console.log(data);
           if(data.success) {

          this.list = data.list;

          }
         data.success ? this.$layer.msg(data.msg) : this.$layer.msg(data.error);



    }


  }
}



// WEBPACK FOOTER //
// ./src/pages/mobile/renewalHistory.vue